import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createSelector } from '@reduxjs/toolkit';
import { omit } from 'lodash';
import { DocumentGroup, KybFormField } from 'constants/business-accounts';
import { KybFieldName, stateName } from './constants';

const localState = state => state[stateName];

export const getRegistration = createSelector(localState, _ref => {
  let {
    registration
  } = _ref;
  return registration;
});
export const getKybFormData = createSelector(localState, _ref2 => {
  let {
    kybFormData
  } = _ref2;
  return kybFormData;
});
export const getBusinessDetails = createSelector(localState, _ref3 => {
  let {
    registration
  } = _ref3;
  return registration.businessDetails;
});
export const getAddresses = createSelector(localState, _ref4 => {
  let {
    registration
  } = _ref4;
  return registration.addresses;
});
export const getBusinessAddress = createSelector(localState, _ref5 => {
  let {
    registration
  } = _ref5;
  return registration.addresses.businessAddress;
});
export const getProfile = createSelector(localState, _ref6 => {
  let {
    registration
  } = _ref6;
  return registration.profile;
});
export const getBusinessRepresentative = createSelector(localState, _ref7 => {
  let {
    registration
  } = _ref7;
  return registration.businessRepresentative;
});
export const getBusinessRepresentativeFirstName = createSelector(localState, _ref8 => {
  let {
    registration
  } = _ref8;
  return registration.businessRepresentative.firstNames;
});
export const getBusinessRepresentativeLastName = createSelector(localState, _ref9 => {
  let {
    registration
  } = _ref9;
  return registration.businessRepresentative.lastName;
});
export const getBusinessRepresentativeBirthdate = createSelector(localState, _ref10 => {
  let {
    registration
  } = _ref10;
  return registration.businessRepresentative.birthday;
});
export const getUiState = createSelector(localState, _ref11 => {
  let {
    uiState
  } = _ref11;
  return uiState;
});
export const getErrors = createSelector(localState, _ref12 => {
  let {
    errors
  } = _ref12;
  return errors;
});
export const getLegalEntityUiState = createSelector(localState, _ref13 => {
  let {
    legalEntityUiState
  } = _ref13;
  return legalEntityUiState;
});
export const getShowGeneralError = createSelector(localState, _ref14 => {
  let {
    showGeneralError
  } = _ref14;
  return showGeneralError;
});
export const getBusinessAddressCity = createSelector(localState, _ref15 => {
  let {
    registration
  } = _ref15;
  return registration.addresses.businessAddress.city;
});
export const getEntityType = createSelector(localState, _ref16 => {
  let {
    registration
  } = _ref16;
  return registration.businessDetails.entityType;
});
export const getIsPhoneNumberPersonal = createSelector(localState, _ref17 => {
  let {
    registration
  } = _ref17;
  return registration.profile.isPhoneNumberPersonal;
});
export const getIsEmailPersonal = createSelector(localState, _ref18 => {
  let {
    registration
  } = _ref18;
  return registration.profile.isEmailPersonal;
});
export const getLegalAddressCity = createSelector(localState, _ref19 => {
  var _registration$address;

  let {
    registration
  } = _ref19;
  return (_registration$address = registration.addresses.legalRepresentativeAddress) === null || _registration$address === void 0 ? void 0 : _registration$address.city;
});
export const getRegistrarName = createSelector(localState, _ref20 => {
  let {
    registration
  } = _ref20;
  return registration.businessDetails.registrarName;
});
export const getLegalCode = createSelector(localState, _ref21 => {
  let {
    registration
  } = _ref21;
  return registration.businessDetails.legalCode;
});
export const getLegalName = createSelector(localState, _ref22 => {
  let {
    registration
  } = _ref22;
  return registration.businessDetails.legalName;
});
export const getVat = createSelector(localState, _ref23 => {
  let {
    registration
  } = _ref23;
  return registration.businessDetails.vat;
});
export const getIsVatDisabled = createSelector(localState, _ref24 => {
  let {
    registration
  } = _ref24;
  return registration.businessDetails.isVatDisabled;
});
export const getIsLegalRepresentativeUbo = createSelector(localState, _ref25 => {
  let {
    kybFormData
  } = _ref25;
  return kybFormData.isLegalRepresentativeUbo;
});
export const getIdentityDocumentExpiryDate = createSelector(localState, _ref26 => {
  let {
    kybFormData
  } = _ref26;
  return kybFormData.identityDocumentExpiryDate;
});
export const getUbos = createSelector(localState, _ref27 => {
  let {
    kybFormData
  } = _ref27;
  return kybFormData.ubos;
});
export const getPaymentsIdentityConfiguration = createSelector(localState, _ref28 => {
  let {
    paymentsIdentityConfiguration
  } = _ref28;
  return paymentsIdentityConfiguration;
});
export const getKybStatus = createSelector(localState, _ref29 => {
  let {
    paymentsIdentityConfiguration
  } = _ref29;
  return paymentsIdentityConfiguration === null || paymentsIdentityConfiguration === void 0 ? void 0 : paymentsIdentityConfiguration.status;
});
export const getDocumentFieldConfigurations = createSelector(localState, _ref30 => {
  let {
    paymentsIdentityConfiguration
  } = _ref30;
  return paymentsIdentityConfiguration === null || paymentsIdentityConfiguration === void 0 ? void 0 : paymentsIdentityConfiguration.documentFieldConfigurations;
});
export const getRequiredFields = createSelector(localState, _ref31 => {
  let {
    paymentsIdentityConfiguration
  } = _ref31;
  return paymentsIdentityConfiguration === null || paymentsIdentityConfiguration === void 0 ? void 0 : paymentsIdentityConfiguration.requiredFields;
});
export const getIdentityDocumentConfiguration = createSelector(getDocumentFieldConfigurations, documentFieldConfigurations => {
  var _documentFieldConfigu;

  return documentFieldConfigurations === null || documentFieldConfigurations === void 0 ? void 0 : (_documentFieldConfigu = documentFieldConfigurations.filter(_ref32 => {
    let {
      group
    } = _ref32;
    return group === DocumentGroup.IdentityDocuments;
  })) === null || _documentFieldConfigu === void 0 ? void 0 : _documentFieldConfigu[0];
});
export const getSupportingDocumentsConfiguration = createSelector(getDocumentFieldConfigurations, documentFieldConfigurations => documentFieldConfigurations === null || documentFieldConfigurations === void 0 ? void 0 : documentFieldConfigurations.filter(_ref33 => {
  let {
    group,
    options
  } = _ref33;
  return group === DocumentGroup.SupportingDocuments && options.length === 1;
}));
export const getIsSupportingDocumentRequired = createSelector(getSupportingDocumentsConfiguration, getRequiredFields, (documentFieldConfigurations, requiredFields) => {
  var _requiredFields$filte;

  const supportingDocumentTypes = documentFieldConfigurations === null || documentFieldConfigurations === void 0 ? void 0 : documentFieldConfigurations.map(_ref34 => {
    let {
      options
    } = _ref34;
    return options === null || options === void 0 ? void 0 : options[0].type;
  });
  return !!(requiredFields !== null && requiredFields !== void 0 && (_requiredFields$filte = requiredFields.filter(field => supportingDocumentTypes === null || supportingDocumentTypes === void 0 ? void 0 : supportingDocumentTypes.includes(field))) !== null && _requiredFields$filte !== void 0 && _requiredFields$filte.length);
});
export const getKybData = createSelector(getKybFormData, getBusinessRepresentativeFirstName, getBusinessRepresentativeLastName, getBusinessRepresentativeBirthdate, getLegalName, getBusinessAddress, getIsLegalRepresentativeUbo, getUbos, getRequiredFields, (kybFormData, firstName, lastName, birthday, legalName, address, isLegalRepresentativeUbo, ubos, requiredFields) => {
  const isUboRequired = requiredFields === null || requiredFields === void 0 ? void 0 : requiredFields.includes(KybFieldName.Ubos); // Expiry date field will not be sent to MangoPay, we save it to our database instead.

  const MangoPayKybData = omit(kybFormData, KybFormField.IdentityDocumentExpiryDate);

  const returnedData = _objectSpread(_objectSpread({}, MangoPayKybData), {}, {
    firstName: firstName !== null && firstName !== void 0 ? firstName : null,
    lastName: lastName !== null && lastName !== void 0 ? lastName : null,
    birthdate: birthday,
    address: _objectSpread(_objectSpread({}, address), {}, {
      name: legalName
    })
  });

  if (isUboRequired && isLegalRepresentativeUbo && address && ubos && firstName && lastName) {
    const firstUbo = ubos[0] || {
      nationality: '',
      birthplaceCountry: '',
      birthplaceCity: ''
    };
    return _objectSpread(_objectSpread({}, returnedData), {}, {
      ubos: [_objectSpread(_objectSpread({}, firstUbo), {}, {
        firstName,
        lastName,
        birthday,
        address
      })]
    });
  }

  return returnedData;
});